import { render, staticRenderFns } from "./SettingsPrinterView.vue?vue&type=template&id=f0cafe50&scoped=true&"
import script from "./SettingsPrinterView.vue?vue&type=script&lang=js&"
export * from "./SettingsPrinterView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPrinterView.vue?vue&type=style&index=0&id=f0cafe50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cafe50",
  null
  
)

export default component.exports